// extracted by mini-css-extract-plugin
export default {"container":"TableThreeMainActivities_container__DbLba"};